<template lang='pug'>
  .fpui-steps(:class='color')
    nav
      .step(ref='steps', v-for='step, index in steps', :class='{active: isActive(index)}', @click='openStep(index)')
        span {{step.header}}
        i.fpui.fpui-chevron-right(v-if='index !== steps.length - 1')
      .border(:style='borderStyle')
    .fpui-steps-content
      slot
    .steps-footer(v-if='footer')
      fpui-button.prev(reverse='reverse', color='blue', @click='$emit("cancel")', v-if='isActive(0)') {{'fpui-steps.cancel'|translate}}
      fpui-button.prev.reverse(
        reverse='reverse',
        color='blue',
        @click='previous()',
        v-if='!isActive(0)'
      ) {{'fpui-steps.previous'|translate}}
      fpui-button.next(
        color='blue',
        v-if='!isActiveLast()',
        :disabled='!isValidActive()',
        @click='next()',
        :class='color'
      )
        | {{'fpui-steps.next'|translate}}
        i.fpui.fpui-angle-right.pull-right(style='font-size:24px')
      fpui-button.next(color='blue', v-if='isActiveLast()', :disabled='!isValid()', @click='$emit("final")', :class='color')
        | {{'fpui-steps.validate'|translate}}
        i.fpui.fpui-angle-right.pull-right(style='font-size:24px')
      .clearfix
    .clearfix
</template>

<script>
export default {
  props: {
    color: { type: String, default: 'blue' },
    footer: { type: Boolean, default: true }
  },
  data () {
    return {
      activeIndex: null,
      steps: [],
      borderStyle: {
        width: '100px',
        marginLeft: '0px'
      }
    }
  },
  created () {
    this.onKeyPress = this.onKeyPress.bind(this)
    window.addEventListener('keydown', this.onKeyPress)
  },
  mounted () {
    if (this.$slots && this.$slots.default && this.$slots.default.length > 0) {
      this.update(null, false)
      this.activeIndex = 0
      process.nextTick(this.setBorderStyle.bind(this))
    }
  },
  destroyed () {
    window.removeEventListener('keydown', this.onKeyPress)
  },
  watch: {
    activeIndex () {
      if (!this.$refs.steps) return
      this.setBorderStyle()
    }
  },
  methods: {
    onKeyPress (event) {
      switch (event.keyCode) {
        case 39:
          this.next()
          break
        case 37:
          this.previous()
          break
        default: break
      }
    },
    update (cb, nextTick = true) {
      if (nextTick) {
        return process.nextTick(this.update.bind(this, cb, false))
      }
      this.steps = this.$slots.default
        .filter(child => child.componentInstance)
        .map((child, index) => {
          child.componentInstance.index = index
          return {
            header: child.componentInstance.header,
            validate: child.componentInstance.validate,
            component: child.componentInstance
          }
        })
      if (typeof cb === 'function') cb()
    },
    setBorderStyle () {
      if (this.$refs.steps && this.$refs.steps.length > 0) {
        let curElem = this.$refs.steps[this.activeIndex]
        let leftElems = this.$refs.steps.slice(0, this.activeIndex)
        // The curElem is not necessarily set here when the step has juste been added
        if (!curElem) { return setTimeout(this.setBorderStyle.bind(this), 100) }
        // In case of step removed and add another one instantly
        process.nextTick(() => {
          const styleCur = window.getComputedStyle(curElem)
          this.borderStyle.width = `${(parseInt(curElem.offsetWidth) + parseInt(styleCur.marginRight) + parseInt(styleCur.marginLeft)) - 30}px`

          if (!leftElems.length) {
            this.borderStyle.left = 0
          } else {
            let left = 0
            for (let el of Array.from(leftElems)) {
              const styleEl = window.getComputedStyle(el)
              left += el.offsetWidth + parseInt(styleEl.marginRight) + parseInt(styleEl.marginLeft)
            }
            this.borderStyle.left = left + 'px'
          }
        })
      }
    },
    previous () {
      if (this.activeIndex >= 1) { this.activeIndex -= 1 }
    },
    goTo (idx) { this.activeIndex = idx },
    next () {
      if (!this.isValidActive() || !this.steps[this.activeIndex + 1]) return
      this.activeIndex += 1
    },
    isValidActive () { return this.isValid(this.active()) },
    isValid (step) {
      if (step && typeof step.validate === 'function') {
        return step.validate()
      }
      return true
    },
    isActiveLast () { return this.activeIndex === this.steps.length - 1 },
    openStep (index) {
      for (let i = 0; i < this.steps.length; i++) {
        if (this.index === i) { break }
        if (!this.isValid(this.steps[i])) {
          return
        }
      }
      this.activeIndex = index
    },
    isActive (stepIndex) { return stepIndex === this.activeIndex },
    active (idx) {
      if (idx) {
        this.activeIndex = idx
        return
      }
      return this.steps[this.activeIndex]
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-steps {
  height: 100%;
  nav {
    text-align: left;
    background-color: #fff;
    border-bottom: 1px solid #bbb;
    position: relative;
    padding-left: 0px;
    font-size: 20px;
    font-family: 'Josefin Sans';
    height: 30px;
    div {
      color: @black;
      display: inline-block;
      line-height: 30px;
      text-transform: uppercase;
      margin-right: 30px;
      position: relative;
      padding: 0 10px;
      cursor: pointer;
      margin-bottom: -1px;
      i {
        position: absolute;
        right: -26px;
        top:0;
        font-size: 20px;
        font-weight: 100;
        color: @grey;
      }
      &.active {
        color: @blue;
      }
    }
    .border {
      height: 3px;
      width: 0px;
      padding: 0;
      margin: 0;
      position: absolute;
      left: 5px;
      bottom: 0;
      background: @blue;
      border: none;
      transition: .3s ease-in-out;
    }
  }
  .fpui-steps-content {
    height: ~"calc(100% - 80px)";
  }
  .step-content {
    padding: 10px 10px;
  }
  .steps-footer {
    z-index: 9999;
    padding: 0 10px;
    width: 100%;
    height: 50px;
    .prev {
      float: left;
    }
    .next {
      float: right;
    }
  }
}

@media (max-width: 520px) {
  .fpui-steps {
    nav {
      font-size: 16px;
      div {
        line-height: 24px;
        margin-right: 25px;
        padding: 0 5px;
        i {
          top: -2px;
          right: -24px;
        }
      }
    }
  }
}

</style>
